import { SettingItem } from '@/features/ai_agents_setting/components/Common';
import { useTranslation } from '@/i18n';
import {
  Caption,
  FormCheckbox,
  TextLink,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../styles.module.scss';

const cx = classnames.bind(styles);

type Props = {
  isEditMode: boolean;
  name: string;
  initialValue: boolean;
  detailLink?: string;
};

export const InvoiceDownloadService: FC<Props> = ({
  isEditMode,
  name,
  initialValue,
  detailLink,
}) => {
  const { t } = useTranslation();
  const { control, watch } = useFormContext();
  const isEnabled = watch(name);
  const showWarning = isEditMode && initialValue && !isEnabled;

  if (isEditMode) {
    return (
      <SettingItem
        label={t('ai_agents_setting_invoice_download_service_title')}
        value={
          <div className={cx('serviceValueContent')}>
            <FormCheckbox
              name={name}
              control={control}
              inputId={name}
              label={t('use')}
              className={cx('serviceCheckboxLabel')}
            />
            {showWarning && (
              <Caption icon type='alert'>
                {t('ai_agents_setting_disable_service_inline_warning_prefix')}
              </Caption>
            )}
            <div className={cx('serviceDescription')}>
              <span>{t('ai_agents_setting_invoice_download_description')}</span>
              <TextLink
                href={detailLink}
                target='_blank'
                className={cx('serviceDescriptionLink')}
              >
                {t('ai_agents_setting_detail_link')}
              </TextLink>
            </div>
          </div>
        }
      />
    );
  }

  return (
    <SettingItem
      label={t('ai_agents_setting_invoice_download_service_title')}
      value={
        <div className={cx('serviceValueContent')}>
          <span className={cx('serviceValueContentText')}>
            {t(initialValue ? 'use' : 'not_use')}
          </span>
          <div className={cx('serviceDescription')}>
            <span>{t('ai_agents_setting_invoice_download_description')}</span>
            <TextLink
              href={detailLink}
              target='_blank'
              className={cx('serviceDescriptionLink')}
            >
              {t('ai_agents_setting_detail_link')}
            </TextLink>
          </div>
        </div>
      }
    />
  );
};

InvoiceDownloadService.displayName = 'InvoiceDownloadService';
